var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length > 0)?_c('div',{staticClass:"referee"},[_c('div',{staticClass:"title"},[_vm._v("比赛裁判")]),_vm._l((_vm.list),function(item){return _c('div',{key:item.refereeId,staticClass:"item"},[_c('div',{staticClass:"role"},[_vm._v(_vm._s(item.role))]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name.join()))])])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }